import { render } from "./TransactionServiceDetail.vue?vue&type=template&id=45512b06&scoped=true"
import script from "./TransactionServiceDetail.vue?vue&type=script&lang=js"
export * from "./TransactionServiceDetail.vue?vue&type=script&lang=js"

import "./TransactionServiceDetail.vue?vue&type=style&index=0&id=45512b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45512b06"]])

export default __exports__